import { Link, useNavigate } from "react-router-dom";
import { LightningIcon, SignOutIcon, StackIcon, SquaresFourIcon, UsersThreeIcon, ShieldCheckIcon } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isAdmin = !!user?.is_admin;
  const home = isAdmin ? "/admin" : "/";
  const loginPath = isAdmin ? "/admin/login" : "/login";

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 bg-background border-b border-border">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to={home} data-testid="nav-home-link" className="flex items-center gap-2 font-heading font-black tracking-tighter text-lg hover:text-primary transition-colors">
            <LightningIcon weight="fill" className={isAdmin ? "text-accent" : "text-primary"} size={22} />
            D CODE {isAdmin && <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-accent border border-accent/40 px-1.5 py-0.5 ml-1">Admin</span>}
          </Link>
          <div className="flex items-center gap-4">
            {isAdmin && (
              <nav className="hidden sm:flex items-center gap-1">
                <Link to="/admin" data-testid="nav-codes-link" className="flex items-center gap-1.5 font-mono text-xs text-white/60 hover:text-primary transition-colors px-2 py-1"><SquaresFourIcon weight="bold" /> CODES</Link>
                <Link to="/admin/inventory" data-testid="nav-inventory-link" className="flex items-center gap-1.5 font-mono text-xs text-white/60 hover:text-primary transition-colors px-2 py-1"><StackIcon weight="bold" /> INVENTORY</Link>
                <Link to="/admin/customers" data-testid="nav-customers-link" className="flex items-center gap-1.5 font-mono text-xs text-white/60 hover:text-primary transition-colors px-2 py-1"><UsersThreeIcon weight="bold" /> CUSTOMERS</Link>
                <Link to="/admin/admins" data-testid="nav-admins-link" className="flex items-center gap-1.5 font-mono text-xs text-white/60 hover:text-primary transition-colors px-2 py-1"><ShieldCheckIcon weight="bold" /> ADMINS</Link>
              </nav>
            )}
            <span data-testid="nav-user-email" className="hidden sm:block font-mono text-xs text-white/50">{user?.email}</span>
            <Button
              data-testid="nav-logout-btn"
              variant="outline"
              size="sm"
              onClick={() => { logout(); navigate(loginPath); }}
              className="border-border bg-transparent hover:bg-secondary hover:text-white font-mono text-xs"
            >
              <SignOutIcon weight="bold" className="mr-1.5" /> LOGOUT
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-6 py-10">{children}</main>
    </div>
  );
}
